import { useCallback, useEffect, useRef, useState } from "react";
import "../styles/InlineCell.css";

// Double-click a cell to edit its value in place, without opening a full
// drawer/modal. Originally lived only in TasksViewV2Page.jsx (Tasks list) —
// promoted here so DefectsViewV2Page can reuse it for the same "instant
// status update" pattern rather than a second hand-rolled copy. Self-contained
// CSS (own `ic-*` class prefix) so it renders correctly regardless of which
// view's own CSS-prefix scope it's used inside.
export default function InlineCell({ value, field, options, onCommit, children }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");
  const ref = useRef(null);

  const commit = useCallback(() => {
    setEditing(false);
    if (draft !== value) onCommit(field, draft);
  }, [draft, value, field, onCommit]);

  useEffect(() => {
    if (editing && ref.current) ref.current.focus();
  }, [editing]);

  if (!editing) {
    return (
      <span
        className="ic-cell"
        onDoubleClick={() => { setDraft(value ?? ""); setEditing(true); }}
      >
        {children}
      </span>
    );
  }

  if (options) {
    return (
      <select
        ref={ref}
        className="ic-select"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
      >
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }

  return (
    <input
      ref={ref}
      className="ic-input"
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
    />
  );
}
